/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/close-adopt': {
    width: 34,
    height: 34,
    viewBox: '0 0 34 34',
    data: '<circle pid="0" cx="16.642" cy="16.642" r="10.768" transform="rotate(45 16.642 16.642)" _fill="#F2FAFE" _stroke="#447077" stroke-width="2"/><path pid="1" _stroke="#447077" stroke-width="2" stroke-linecap="round" d="M19.905 13.414l-6.491 6.491M19.491 19.904L13 13.414"/>'
  }
})
